<header>
    <div class="left">
        <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
    </div>

    <div class="right mobile-hide">

    </div>
</header>

<div class="content">

    <div class="image-upload">
        <ngx-dropzone #masonry class="dropzone" expandable="true" (change)="startUploadImage($event)" accept="image/jpeg,image/jpg,image/png,image/gif">
            <ngx-dropzone-label>Upload image</ngx-dropzone-label>
        </ngx-dropzone>
    </div>

    <div class="images">
        <div class="image" *ngFor="let social of socialAssets;let i = index">
            <img (click)="openImageDialog(social, i)" [src]="getUrl(social)">
        </div>
    </div>
</div>